import Nullstack from 'nullstack';
export default function IconBrandSpotify({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brand-spotify",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "12",
    r: "9"
  }), "   ", Nullstack.element("path", {
    d: "M8 11.973c2.5 -1.473 5.5 -.973 7.5 .527"
  }), "   ", Nullstack.element("path", {
    d: "M9 15c1.5 -1 4 -1 5 .5"
  }), "   ", Nullstack.element("path", {
    d: "M7 9c2 -1 6 -2 10 .5"
  }), " ");
}